import { useEffect, useState } from 'react';
import useHttp from '../../../../hooks/use-http';
import MuiDialog from '../../../UI/MuiDialog/MuiDialog';
import GridProvider from './components/GridProvider';
import Inputs from './components/Inputs';
import { urls } from './api/urls';
import toast from 'react-hot-toast';
import { handleErrorMessage } from '../../../../../shared/api/handleErrorMessage';
import { useTranslation } from 'react-i18next';
import MultiSelectDialog from '../../../UI/MultiSelectDialog/MultiSelectDialog';

const INITIAL_VALUES = {
  napomena: '',
  idDok: 0, // id radnog naloga
  id: 0, // id stavke
  proveravanaStavka: '',
  cekirano: false,
};

const StavkePustanja = ({ idRn }) => {
  const { t } = useTranslation();
  const { sendRequest, data, getData, isLoading } = useHttp('');
  const { sendRequest: getIstorijaStavke, data: istorijaStavkeData } =
    useHttp('');

  const [formValue, setFormValue] = useState(INITIAL_VALUES);
  const [openDialogForm, setOpenDialogForm] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openMultiDialog, setOpenMultiDialog] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);

  const vratiStavke = () => {
    const config = {
      method: 'POST',
      url: urls.VRATI_STAVKE_ZA_RN,
      data: { id: idRn },
    };
    sendRequest(config);
  };
  useEffect(() => {
    vratiStavke();
  }, []);
  useEffect(() => {
    if (openMultiDialog) {
      const config = {
        url: urls.GET_ISTORIJA_STAVKE,
      };
      getIstorijaStavke(config);
    }
  }, [openMultiDialog]);

  const handleOpenDeleteDialog = (id) => {
    setFormValue((curr) => {
      return { ...curr, id: id };
    });
    setOpenDeleteDialog(true);
  };
  const handleCloseDelete = () => {
    setFormValue(INITIAL_VALUES);
    setOpenDeleteDialog(false);
  };
  const handleOpenDialogForm = (item) => {
    if (item.id > 0) {
      setFormValue(item);
    } else {
      setFormValue(INITIAL_VALUES);
    }
    setOpenDialogForm(true);
  };

  const handleSave = async () => {
    const config = {
      method: 'POST',
      url: urls.INSERT_UPDATE_STAVKE,
      data: {
        ...formValue,
        idKorProm: +localStorage.getItem('idKorisnika'),
        idDok: idRn,
      },
    };

    const result = await getData(config);
    if (result.id > 0) {
      vratiStavke();
      setFormValue(INITIAL_VALUES);
      toast.success(
        formValue.id === 0 ? 'Uspešan unos podatak' : 'Uspešna izmena podataka',
      );
      return;
    }
    toast.error(handleErrorMessage(result));
  };
  const handleDelete = async () => {
    const config = {
      method: 'POST',
      url: urls.DELETE_STAVKE,
      data: { id: formValue.id },
    };
    const result = await getData(config);
    if (result > 0) {
      toast.success('Uspešano obrisan podatak');
      setFormValue(INITIAL_VALUES);
      setOpenDeleteDialog(false);
      vratiStavke();
      return;
    }
    toast.error('Greška prilikom brisanja podatka');
  };
  const handleOpenMultiDialog = () => {
    setOpenMultiDialog(true);
  };
  const handleCloseMultiDialog = () => {
    setOpenMultiDialog(false);
  };
  const handleSaveListStavke = async (stavka) => {
    const config = {
      method: 'POST',
      url: urls.INSERT_UPDATE_STAVKE,
      data: {
        ...INITIAL_VALUES,
        proveravanaStavka: stavka,
        idKorProm: +localStorage.getItem('idKorisnika'),
        idDok: idRn,
      },
    };

    const result = await getData(config);
  };
  const handleConfirmStavkeMulti = () => {
    console.log('SELEKTOVANE STAVKE', selectedItems);
    if (selectedItems?.length === 0) {
      toast.error('Potrebno je izabrati stavku.');
      return;
    }

    selectedItems.forEach((item) => {
      handleSaveListStavke(item.vrednost);
    });
    vratiStavke();
    setSelectedItems([]);
    toast.success('Uspešan unos podatak');
  };
  return (
    <div>
      <GridProvider
        data={data}
        handleOpenDeleteDialog={handleOpenDeleteDialog}
        handleOpenDialogForm={handleOpenDialogForm}
        handleOpenMultiDialog={handleOpenMultiDialog}
        isLoading={isLoading}
      />
      <MuiDialog
        maxWidth="sm"
        open={openDialogForm}
        title="Stavka"
        content={
          <Inputs
            formValue={formValue}
            setFormValue={setFormValue}
            idRn={idRn}
          />
        }
        handleClose={() => setOpenDialogForm(false)}
        handleConfirm={handleSave}
        deniedText="ZATVORI"
      />
      <MuiDialog
        maxWidth="sm"
        open={openDeleteDialog}
        title={t('warning')}
        text={t('warningDelete')}
        handleClose={handleCloseDelete}
        handleConfirm={handleDelete}
        deniedText="ZATVORI"
      />
      <MultiSelectDialog
        data={istorijaStavkeData}
        openDialog={openMultiDialog}
        handleClose={handleCloseMultiDialog}
        setSelectedItems={setSelectedItems}
        selectedItems={selectedItems}
        handleConfirm={handleConfirmStavkeMulti}
        title="Stavke"
        readProp="proveravanaStavka"
      />
    </div>
  );
};

export default StavkePustanja;
